import React from 'react';

/**
 * Providers page for a specific agent profile.
 */
export const ProfileProviders = () => {
  return (
    <div>
      <h2>Agent Profile Providers</h2>
    </div>
  );
};

export default ProfileProviders;
